import { moreApps } from "../../utils/constants";

function MoreApps() {
  return (
    <>
      <div className="more-apps">
        <img width={"18px"} height={"18px"} src={moreApps} alt="more-apps" />
      </div>
    </>
  );
}

export default MoreApps;
